import React from 'react';
import { SectionBlocks } from '@components/SectionBlocks';
import { Layout } from '@components/layout/Layout';
import { ElbilAppType, MembershipBenefitsAppType, RoutePlannerAppType } from '@appTypes/CategoryAppType';
import { SiteStructureType } from '@appTypes/siteStructureType';
import FeedbackSurvey from '@components/feedbacksurvey/FeedbackSurvey';
import { useWindowLocation } from '@hooks/Window/useWindowLocation';
import ErrorBoundary from '@components/error-component/ErrorBoundary';
import { InternalSearchCardType } from '@components/layout/InternalSearchMetaData';
import { Hero } from './Hero';
import * as S from './DynamicApp.styles';

export const DynamicApp = ({
  data,
  appData,
}: {
  data: SiteStructureType;
  appData?: ElbilAppType | MembershipBenefitsAppType | RoutePlannerAppType;
}) => {
  const contentUrl = useWindowLocation();

  return (
    <Layout
      title={data.seoConfig?.title || data.name}
      description={data.seoConfig?.introduction || data.ingress || ''}
      gtmArgs={{
        page_type: appData.name.charAt(0).toUpperCase() + appData.name.slice(1),
        pageCategory: data.slug,
        contentId: data.name,
      }}
      isHiddenFromSearch={data?.seoConfig?.isHiddenFromSearch}
      internalSearchMetaData={{ cardType: InternalSearchCardType.CategoryApp }}
    >
      <Hero hero={appData.properties.hero} />
      <S.Main>
        <ErrorBoundary>
          <S.SectionContainer>
            <SectionBlocks content={appData.properties.sections} />
          </S.SectionContainer>
          <S.FeedbackContainer>
            <FeedbackSurvey contentUrl={contentUrl} />
          </S.FeedbackContainer>
        </ErrorBoundary>
      </S.Main>
    </Layout>
  );
};
